import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Swipeable from 'react-swipeable';

class View360 extends Component {
  static propTypes = {
    src: PropTypes.any.isRequired,
    defaultAngle: PropTypes.number,
    speed: PropTypes.number,
    onUpdate: PropTypes.func,
  };
  
  static defaultProps = {
    onUpdate: f => f,
    speed: 1.5,
    defaultAngle: 180,
  };

  constructor(props) {
    super(props);
    this.angle = this.props.defaultAngle;
    this.state = {
      positionX: this.props.defaultAngle / 360 * 100, // initial background position
    };
  }

  componentDidMount() {
    this.swipeStarted = false;
    this.image = new Image();
    this.image.src = this.props.src;
    this.image.onload = () => {
      this.handleImageLoad();
      window.addEventListener('resize', this.handleResize.bind(this));
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.src !== prevProps.src) {
      this.handleNewSrc(this.props.src);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  updateImageViewWidth() {
    this.imageViewWidth =
      this.$view.clientHeight / this.image.height * this.image.width;
  }

  handleNewSrc = src => {
    this.image = new Image();
    this.image.src = src;
    this.image.onload = () => {
      this.updateImageViewWidth();
      this.setState(
        {
          positionX:
            this.imageViewWidth * (1 - this.angle / 360) +
            window.innerWidth * 0.5,
        },
        () => {
          this.calculateAngle();
        }
      );
    };
    
  };
  
  handleImageLoad = () => {
    this.updateImageViewWidth();
    this.setState({
      positionX:
      this.imageViewWidth * (1 - this.angle / 360) + window.innerWidth * 0.5,
    },
      () => {
        this.calculateAngle();
      }
    );
  };
  
  handleResize = () => {
    this.calculateAngle();
  };

  handleSwiping = (e, deltaX, deltaY, absX, absY, velocity) => {
    if (!this.swipeStarted) {
      this.swipeStarted = true;
      this.prevPosition = deltaX;
    }
    let delta = this.prevPosition - deltaX;
    this.prevPosition = deltaX;
    this.setState({
      positionX: this.state.positionX + delta * (1.5),
    });
    this.calculateAngle();
  };

  handleSwiped = () => {
    this.swipeStarted = false;
  };

  calculateAngle = () => {
    this.updateImageViewWidth();
    const percentage =
      1 -
      (this.state.positionX - window.innerWidth * 0.5) / this.imageViewWidth;
    this.angle = percentage * 360;
    this.props.onUpdate(this.angle);
  };

  render() {
    return (
      <Swipeable
        onSwiping={this.handleSwiping}
        onSwiped={this.handleSwiped}
        trackMouse
        style={{
          backgroundPositionX: `${this.state.positionX}px`,
          backgroundImage: `url(${this.props.src}`,
          height: '100%',
          width: '100%',
          backgroundSize: 'cover',
        }}
      >
        <div
          style={{ height: '100%', width: '100%' }}
          ref={ref => (this.$view = ref)}
        />
      </Swipeable>
    );
  }
}

export default View360;



// WEBPACK FOOTER //
// ./src/pages/Views/elements/Panorama/elements/View360.js